import React from 'react';
import $ from 'jquery';

import FInput from './fInputComponent';
import FCheckbox from './fCheckboxComponent';

import { $scrollTo } from './../../mixin/mixin-jquery';

class Filter extends React.Component {
  constructor() {
    super();

    this._handleReset = this._handleReset.bind(this);
    this._$scrollTo = $scrollTo;
  }

  componentDidMount() {
    /* Bind events - jQuery */
    this._$scrollTo($('.widget.unit-filter .btn-submit'), $('#degrees-wrap'));
  }

  render() {
    let total = this.props.count;
    let resultMsg = total === 0 ? 'No ' +this.props.searchResultName+' found' : '<strong>' + total + '</strong> '+this.props.searchResultName+' found';

    return <div className="widget unit-filter">
      <div className="widget-inner">
        <h3>Filter</h3>
        <form action="" method="POST" noValidate="novalidate">

            <label htmlFor="query-degree-name" className="visuallyhidden">Search</label>
            <FInput data={this.props.term}
                    dispatchReducer={this.props.dispatchReducer} placeholderText={this.props.placeholderText}/>
            <div className="sq-form-control clearfix">
            { this.props.initLoad ? null :
                  <p className="result-msg" dangerouslySetInnerHTML={{__html: resultMsg}} /> }
            </div>
            <fieldset>
              <legend className="sq-form-question-title visuallyhidden">Question 1</legend>

              <div className="sq-form-question-answer overflow-scroll">

                <FCheckbox data={this.props.disciplines}
                           value={this.props.currDisciplines}
                           dispatchReducer={this.props.dispatchReducer} />

              </div>
              <div className="sq-form-control clearfix">
    				    <button type="Reset"
                       className="button type-3 btn-reset"
                       onClick={this._handleReset}>
                       RESET FILTER
                </button>

                <button type="Submit"
                       name="form_email_148635_submit"
                       className="button type-2 btn-submit"
                       id="form_email_148635_submit">
                       View Results
                </button>
        		  </div>
            </fieldset>

        </form>
      </div>
    </div>;
  }

  _handleReset() {
    let action = {
      type:       'ALL::RESET',
      fireFilter: true
    }
    this.props.dispatchReducer(action);
  }
}

Filter.propTypes = {
  disciplines:        React.PropTypes.array.isRequired,
  currDisciplines:    React.PropTypes.array.isRequired,
  term:               React.PropTypes.string.isRequired,
  initLoad:           React.PropTypes.bool.isRequired,
  count:              React.PropTypes.number.isRequired,
  dispatchReducer:    React.PropTypes.func.isRequired
};

export default Filter;
